import Link from 'next/link'
import { TrackedBillsProps } from '..'
import { BookmarkCheck } from 'lucide-react'

import { Button } from '@/components/ui/button'

import { BillsListing } from './BillsListing'

const NoBills: React.FC = () => {
  return (
    <div className="mx-auto flex max-w-sm items-center justify-center gap-2 rounded-2xl py-8 font-body lg:pt-2 lg:pb-8 xl:pt-6 xl:pb-16">
      <div className="flex flex-col items-center justify-center gap-4 text-center text-balance">
        <div className="flex size-14 items-center justify-center rounded-xl bg-evergreen-100 p-2">
          <BookmarkCheck className="size-8 text-evergreen-800" />
        </div>
        <h3 className="text-2xl font-semibold text-foreground">
          Start tracking bills that matter to you.
        </h3>
        <p className="text-reg text-card-foreground">
          Follow specific legislation to see real‑time updates here, including status changes, key
          votes, and alerts on the issues you care about most.
        </p>
        <div className="flex items-center justify-center gap-2">
          <Button variant="accent" className="flex w-fit items-center" asChild>
            <Link href={`/legislative-tracker`}>Browse bills</Link>
          </Button>
        </div>
      </div>
    </div>
  )
}

export const TrackedBills = ({ bills, allBillTopics }: TrackedBillsProps) => {
  return bills.length === 0 ? (
    <NoBills />
  ) : (
    <BillsListing bills={bills} allBillTopics={allBillTopics} />
  )
}
